const Rollbar = require('rollbar');

const rollbar = new Rollbar({
    accessToken: process.env.REACT_APP_ROLLBAR_KEY,
    environment: process.env.REACT_APP_ROLLBAR_ENV
});

module.exports = rollbar;